export default __webpack_public_path__ + "static/media/thumbnail.6d23e729.png";